import { inject, Injectable } from '@angular/core';
import { IfFeatureService } from '../if-feature/if-feature.service';

import { CONSUMER_TYPE, CONSUMERS, ConsumerType } from '../../domain/consumer-type.domain';
import {
  ModalIdLite,
  ModalTriggerConfiguration,
  ModalType,
  MODAL_NOTIFICATION_CONFIGURATION,
  TriggerConfiguration,
  TriggerLinkIdType,
  TriggerType,
  ModalIdWB
} from './modal-notification.domain';

@Injectable({
  providedIn: 'root'
})
export class ModalNotificationMultipleService {

  private static readonly FEATURE_FLAG: string = 'multipleWhatsNewModal';

  private readonly featureService = inject(IfFeatureService);
  private readonly triggerConfiguration: TriggerConfiguration = inject<TriggerConfiguration>(MODAL_NOTIFICATION_CONFIGURATION);
  private readonly consumer: ConsumerType = inject<ConsumerType>(CONSUMER_TYPE);

  hasMultipleWhatsNewModal(): boolean {
    return this.featureService.getFeatureFlag(ModalNotificationMultipleService.FEATURE_FLAG) &&
      Object.values(this.triggerConfiguration)[0]?.modalType === ModalType.WHATS_NEW;
  }

  getMultipleWhatsNewModal(): Array<ModalTriggerConfiguration> {
    const modals = Object.values(this.triggerConfiguration);
    const allWhatsNew = modals.filter((config: ModalTriggerConfiguration) => config.modalType === ModalType.WHATS_NEW);
    return allWhatsNew.slice(0, 3);
  }

  getMultipleWhatsNewTrigger(): ModalTriggerConfiguration {
    return {
      id: this.isWebbroker() ? ModalIdWB.WHATS_NEW : ModalIdLite.WHATS_NEW,
      triggerLinkId: TriggerLinkIdType.ANY_URL,
      persistence: TriggerType.PER_USER,
      modalType: ModalType.WHATS_NEW
    };
  }

  private isWebbroker(): boolean {
    return this.consumer.consumerId === CONSUMERS.CONSUMER_ID_WEB_BROKER;
  }
}
